module.exports = __webpack_public_path__ + "static/media/12.99492839.jpg";